import { render, staticRenderFns } from "./AdminReports.vue?vue&type=template&id=84ce9b94&scoped=true"
import script from "./AdminReports.vue?vue&type=script&lang=js"
export * from "./AdminReports.vue?vue&type=script&lang=js"
import style0 from "./AdminReports.vue?vue&type=style&index=0&id=84ce9b94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ce9b94",
  null
  
)

export default component.exports